/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    localStorageTokenKey : "token",
    loginPath : "/business-auth",
    registerPath : "/business-auth",
    baseUrl : 'https://sworld.co.uk/',
    getShop: 'SworldApi/SworldEcommerceApi/api.php?o=getShop',
    getBusiness: '/assets/sworld-business/mock/getBusiness.json',
    getUc: 'SworldWebApi/api/places/getUC/index.php',
    getContent : 'SworldWebApi/api/places/getContent/index.php',
    getDt : 'SworldApi/SworldEcommerceApi/api.php?o=get_dt',
    uploadImage : "SworldWebApi/api/places/UploadFile/index.php",
    deleteUploadedImage : "SworldWebApi/api/places/DeleteUploadFile/index.php",
    getBh : "SworldApi/SworldEcommerceApi/api.php?o=get_bh",
    insertBh : "SworldApi/SworldEcommerceApi/api.php?o=insert_bh",
    maxImageUploadSize : 1500000,
    maxImageUploadSizeErrorText : "1,5 MB",
    ticketTemplatePPTPath :  "sworld_print_templates_200721_02.pptx"
  }
};
